export enum Cohort {
    Dtc = 'direct_to_consumer',
}
